import React from "react";
import {useAuthState} from "react-firebase-hooks/auth";

import {faPlus, faUsers} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";
import {useGroup} from "~/contexts/group/GroupProvider";
import {auth} from "~/firebase/firebase";

const createNewGroupId = (hostId: string) => {
  return hostId + Math.random().toString(36).substring(2, 9);
};

const CreateGroupView: React.FC = () => {
  const [user] = useAuthState(auth);

  const {joinGroup} = useGroup();

  const handleCreateGroup = () => {
    if (user?.uid) joinGroup(createNewGroupId(user.uid));
  };

  return (
    <div className="flex flex-col items-center justify-center text-center p-8">
      <div className="w-24 h-24 bg-gray-800 rounded-full flex items-center justify-center mb-6">
        <FontAwesomeIcon icon={faUsers} className="text-gray-500 text-5xl" />
      </div>
      <h3 className="text-2xl font-bold text-white mb-2">Play with Friends</h3>
      <p className="text-gray-400 mb-8">
        Create a group to invite your friends and play levels together in
        real-time.
      </p>
      <CustomButton
        onClick={handleCreateGroup}
        className="w-full bg-blue-600/90 hover:bg-blue-500/90 flex items-center justify-center text-lg py-3"
      >
        <FontAwesomeIcon icon={faPlus} className="mr-2" />
        Create New Group
      </CustomButton>
    </div>
  );
};

export default CreateGroupView;
